import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root'
})
export class EnvService {

    /**
     * Access to env properties with a yaml-like syntax
     * @param path
     */
    get(path: string): any {
        const split = path.split('.');
        let obj = environment as any;
        for (const segment of split) {
            obj = ((obj as any) || {})[segment];
        }
        return obj ?? null;
    }

    get isProduction() {
        return environment.production;
    }
}
